import type { Project } from "@tasduvar/engine";
import { fromProjectFile } from "../../storage";
import vitrin from "../../examples/vitrin.json";

/** Ana sayfadaki "Örnek projeyle dene": her açılışta yeni kimlikle kopya (kullanıcı bozarsa yeniden açılabilir). */
export function showcaseProject(): Project {
  const p = fromProjectFile(vitrin);
  const now = new Date().toISOString();
  return { ...p, id: `vitrin-${Date.now().toString(36)}`, createdAt: now, updatedAt: now };
}
